import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

export const LoadingScreen = ({ onDone }) => {
  const [visible, setVisible] = useState(true);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    // Long enough for the wave to draw (~1.2s) and the wordmark to fade in
    // (starts at 0.85s, finishes at 1.45s) plus a beat of rest before exiting.
    const minDelay = new Promise((resolve) => setTimeout(resolve, 2100));
    const pageLoad = new Promise((resolve) => {
      if (document.readyState === "complete") {
        resolve();
      } else {
        window.addEventListener("load", resolve, { once: true });
      }
    });
    const safety = new Promise((resolve) => setTimeout(resolve, 4500));

    Promise.race([Promise.all([minDelay, pageLoad]), safety]).then(() => {
      setVisible(false);
      onDone?.();
    });
  }, [onDone]);

  useEffect(() => {
    document.body.style.overflow = visible ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="loading-screen"
          data-testid="loading-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#1c2419]"
        >
          <motion.div
            animate={reduceMotion ? {} : { scale: [1, 1.045, 1] }}
            transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut" }}
          >
            <svg
              width="120"
              height="40"
              viewBox="0 0 200 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <motion.path
                d="M10 20 Q 35 2 60 20 T 110 20 T 160 20 T 190 20"
                stroke="#F9F7F3"
                strokeWidth="7"
                strokeLinecap="round"
                initial={reduceMotion ? { opacity: 1 } : { pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{ duration: 1.05, ease: "easeInOut" }}
              />
              <motion.path
                d="M10 42 Q 35 24 60 42 T 110 42 T 160 42 T 190 42"
                stroke="#F9F7F3"
                strokeWidth="7"
                strokeLinecap="round"
                initial={reduceMotion ? { opacity: 1 } : { pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{ duration: 1.05, ease: "easeInOut", delay: 0.18 }}
              />
            </svg>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.85 }}
            className="font-brand mt-5 text-xl tracking-wide text-[#F9F7F3]"
          >
            Lake House Juno
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
